<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Información Corredores</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>

          <b-row class="my-1">
            <b-col sm="2">
              <label style="text-aling: rigth">Año</label>
            </b-col>
            <b-col sm="2">
              <b-form-input
                  type="number"
                  v-model="datosFormulario.ano"
                >
                </b-form-input>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.ano
              }}</span>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions text-right">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar"
                    ><i class="fa fa-search"></i> Consultar</b-button
                  >
                  <b-button
                    variant="primary"
                    @click="pre_insertar"
                    style="margin-left: 10px"
                    ><i class="fa fa-eraser"></i> Limpiar</b-button
                  >
                  <b-button variant="primary" @click="descargarExcel" v-show="exportar" style="margin-left: 10px"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true" v-show="data != ''? true : false">
          <div slot="header">
            <strong>Información Corredor</strong>
          </div>
          <b-row>
            <b-col lg="6">

            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  prop = "nomcorredor"
                  min-width = "320"
                  label = "Nombre Corredor"
                  key= "Nombre Corredor"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "rutcorredor"
                  min-width = "80"
                  label = "Rut Corredor"
                  key= "Rut Corredor"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "codcorredor"
                  min-width = "80"
                  label = "Código"
                  key= "Código"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "cantpolcre"
                  min-width = "80"
                  label = "Nro. Pólizas Crédito"
                  key= "Nro. Pólizas Crédito"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                 <el-table-column
                  prop = "porpolcrered"
                  min-width = "80"
                  label = "%"
                  key= "porpolcrered"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "mtoasegcre"
                  min-width = "100"
                  label = "Monto Aseg. Crédito UF"
                  key= "Monto Aseg. Crédito UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "pormtoasegred"
                  min-width = "80"
                  label = "%"
                  key= "pormtoasegred"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "primacre"
                  min-width = "100"
                  label = "Prima Crédito UF"
                  key= "Prima Crédito UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "porprimacrered"
                  min-width = "80"
                  label = "%"
                  key= "porprimacrered"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "cantcotiz"
                  min-width = "100"
                  label = "Nro. Cotizaciones Crédito"
                  key= "Nro. Cotizaciones Crédito"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "porcotred"
                  min-width = "80"
                  label = "%"
                  key= "porcotred"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "mtoasegcot"
                  min-width = "100"
                  label = "Monto Aseg. Cot. Crédito UF"
                  key= "Monto Aseg. Cot. Crédito UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "pormtoasegcotred"
                  min-width = "80"
                  label = "%"
                  key= "pormtoasegcotred"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "primacot"
                  min-width = "100"
                  label = "Prima Est. Cot. Crédito UF"
                  key= "Prima Est. Cot. Crédito UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "pormtoprimred"
                  min-width = "80"
                  label = "%"
                  key= "pormtoprimred"
                  align= "right"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "cantpolemi"
                  min-width = "100"
                  label = "Nro. Pólizas Emitidas"
                  key= "Nro. Pólizas Emitidas"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "porcotemired"
                  min-width = "80"
                  label = "%"
                  key= "porcotemired"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "cantpolgar"
                  min-width = "100"
                  label = "Nro. Pólizas Garantía"
                  key= "Nro. Pólizas Garantía"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "porpolgarred"
                  min-width = "80"
                  label = "%"
                  key= "porpolgarred"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "primagar"
                  min-width = "100"
                  label = "Prima Garantía UF"
                  key= "Prima Garantía UF"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "porprimagarred"
                  min-width = "80"
                  label = "%"
                  key= "porprimagarred"
                  align= "center"
                  sortable="custom"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformacionCorredor from "@/components/services/apiInformacionCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "InformaciónCorredor",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      isChile: false,
      hasPoliza: false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },
      selectedCor: [],
      selectedDire: [],

      modalModificar: false,

      data: [],
      nombreexcel: "InformaciónCorredor.xls",

      titles: [
        {
          prop: "nomcorredor",
          label: "Nombre Corredor",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "rutcorredor",
          label: "Rut Corredor",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "codcorredor",
          label: "Código",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "cantpolcre",
          label: "Nro. Pólizas Crédito",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "porpolcre",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "mtoasegcre",
          label: "Monto Aseg. UF",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "pormtoaseg",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "primacre",
          label: "Prima Crédito UF",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "porprimacre",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "cantcotiz",
          label: "Nro. Cotizaciones Crédito",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "porcot",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "mtoasegcot",
          label: "Monto Aseg. Cot. UF",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "pormtoasegcot",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "primacot",
          label: "Prima Est. Cot. UF",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "pormtoprim",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "cantpolemi",
          label: "Nro. Pólizas Emitidas",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "porcotemi",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "cantpolgar",
          label: "Nro. Pólizas Garantía",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "porpolgar",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        {
          prop: "primagar",
          label: "Prima Garantía UF",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "porprimagar",
          label: "%",
          align: "center",
          minwidth: "70",
        },
        

      ],

      titlesDinamic: [],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          //    console.log(prop);
              if (prop === 'fechaemision'){

                let elDate = new Date(row["fechaemision"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }

              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }

            })

          }
        }
      ],

      mostrarFechas: true,

      datosFormulario: {
          ano:"",
          fecha_cambio:"",
          valor_uf: 0,
          valor_peso: 0,
          valor_eu: 0,
          valor_us: 0
      },

      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: true,
        maxHeight: 600
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
    methods: {

    llenaArrayLista(data, valor, texto, isDate) {
      var arr = new Array();
      for (var i = 0; i < data.length; i++) {
        var obj = new Object();
        if (isDate) {
          obj.value = this.convierteFecha(data[i][valor]);
          obj.text = this.convierteFecha(data[i][texto]);
        } else {
          obj.value = data[i][valor].toString();
          obj.text = data[i][texto];
        }
        arr.push(obj);
      }
      return arr;
    },

    pre_insertar() {
      this.$Progress.start();
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.ano = null;
     
      this.hasPoliza = false;

      return apiInformacionCorredor
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          if (response.data.res[0].codpais == 'CL'){
            this.isChile = true;
          }

          this.datosFormulario.ano = response.data.res[0].hoy;

          //Carga de listados todos
          var obj = new Object();
          obj.value = "T";
          obj.text = "Todos";

          this.datosFormularioEstado = response.data.festado;

          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      this.exportar = false;
      return apiInformacionCorredor
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.ano)
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;
          console.log(this.data);

          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }
          this.datosFormulario.valor_uf = response.data.res2[0].fecha_cambio;
          this.datosFormulario.valor_uf = response.data.res2[0].valor_uf;
          this.datosFormulario.valor_peso = response.data.res2[0].valor_peso;
          this.datosFormulario.valor_eu = response.data.res2[0].valor_eu;
          this.datosFormulario.valor_us = response.data.res2[0].valor_us;

        
          this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "fechaemision") && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      // } else if ((column.property == "porpolcre" || column.property == "pormtoaseg" || column.property == "porprimacre" 
      //          || column.property == "porcot"    || column.property == "pormtoasegcot" || column.property == "pormtoprim" || column.property == "porcotemi"
      //          || column.property == "porpolgar" || column.property == "porprimagar") && row[column.property]) {
      //   if (row[column.property] == -1 || row[column.property] == "-1"){
      //     return "N/A";
      //   }
      //   if (row[column.property] == 0 || row[column.property] == "0") {
      //      return row[column.property];
      //   } else {
      //     return this.$numeral(row[column.property]).format("0,0.00");
      //   }
      } else if ((column.property == "mtoasegcre" || column.property == "primacre" || column.property == "mtoasegcot" 
                || column.property == "primacot" 
                || column.property == "primagar" ) && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          // return this.$numeral(row[column.property]).format("0,0");
          return this.$numeral(row[column.property]).format();
          //return row[column.property];
        }
      } else {
        return row[column.property];
      }
    },

    totales(param) {
      
      const { columns, data } = param;

      const sums = [];
      this.porpolcrered = 0;
      this.pormtoasegred = 0;
      this.porprimacrered = 0;
      this.porcotred = 0;
      this.pormtoasegcotred = 0;
      this.pormtoprimred = 0;
      this.porcotemired = 0;
      this.porpolgarred = 0;
      this.porprimagarred = 0;

      data.forEach((column, index) => {   
           if (column["porpolcrered"] != undefined) {
                   this.porpolcrered +=  column["porpolcrenro"]; 
           }  
           if (column["pormtoasegred"] != undefined) {
                   this.pormtoasegred +=  column["pormtoasegnro"]; 
           }  
           if (column["porprimacrered"] != undefined) {
                   this.porprimacrered +=  column["porprimacrenro"]; 
           }  
            if (column["porcotred"] != undefined) {
                   this.porcotred +=  column["porcotnro"]; 
           }  
           if (column["pormtoasegcotred"] != undefined) {
                   this.pormtoasegcotred +=  column["porasegcotnro"]; 
           }  
           if (column["pormtoprimred"] != undefined) {
                   this.pormtoprimred +=  column["pormtoprimnro"]; 
           }  
            if (column["porcotemired"] != undefined) {
                   this.porcotemired +=  column["porcoteminro"]; 
           }  
           if (column["porpolgarred"] != undefined) {
                   this.porpolgarred +=  column["porpolgarnro"]; 
           }  
           if (column["porprimagarred"] != undefined) {
                   this.porprimagarred +=  column["porprimagarnro"]; 
           }      
      })

      columns.forEach((column, index) => {

          if (index === 0) {
              sums[index] = 'Total';
              return;
          }
          if (column.property === "codcorredor") {
            return;
          }
          if (column.property === "porpolcrered") {
             sums[index] =  this.$numeral(this.porpolcrered).format("0,0")+"%";
             return;
          }
          if (column.property === "pormtoasegred") {
             sums[index] =  this.$numeral(this.pormtoasegred).format("0,0")+"%";
             return;
          }
          if (column.property === "porprimacrered") {
             sums[index] =  this.$numeral(this.porprimacrered).format("0,0")+"%";
             return;
          }
          if (column.property === "porcotred") {
             sums[index] =  this.$numeral(this.porcotred).format("0,0")+"%";
             return;
          }
          if (column.property === "pormtoasegcotred") {
             sums[index] =  this.$numeral(this.pormtoasegcotred).format("0,0")+"%";
             return;
          }
          if (column.property === "pormtoprimred") {
             sums[index] =  this.$numeral(this.pormtoprimred).format("0,0")+"%";
             return;
          }
          if (column.property === "porcotemired") {
             sums[index] =  this.$numeral(this.porcotemired).format("0,0")+"%";
             return;
          }
          if (column.property === "porpolgarred") {
             sums[index] =  this.$numeral(this.porpolgarred).format("0,0")+"%";
             return;
          }
          if (column.property === "porprimagarred") {
             sums[index] =  this.$numeral(this.porprimagarred).format("0,0")+"%";
             return;
          }
          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format(); 
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:0,0; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:0,0; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl289618 =
        //"padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:0,00%; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:0,0000000000%; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
     
      
      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo += "<td></td>\n";
      cuerpo += "<td></td>\n";
      cuerpo += "<td colspan="+6+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Comercial Crédito</td>\n";
      cuerpo += "<td colspan="+8+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Ventas Crédito</td>\n";
      cuerpo += "<td colspan="+4+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Garantía</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";

      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
             "<td class=xl659618 style='height:15.0pt;border-left:none;" +
          xl659618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
        var sumdata1 = [];
        sumdata1["A1"] = 0;
        sumdata1["A2"] = 0;
        sumdata1["A3"] = 0;
        sumdata1["A4"] = 0;
        sumdata1["A5"] = 0;
        sumdata1["A6"] = 0;
        sumdata1["A7"] = 0;
        sumdata1["A8"] = 0;
        sumdata1["A9"] = 0;
        sumdata1["A10"] = 0;
        sumdata1["A11"] = 0;
        sumdata1["A12"] = 0;
        sumdata1["A13"] = 0;
        sumdata1["A14"] = 0;
        sumdata1["A15"] = 0;
        sumdata1["A16"] = 0;
        sumdata1["A17"] = 0;
        sumdata1["A18"] = 0;
      for (var key in this.data) {
          sumdata1["A1"] += this.data[key]["cantpolcre"];
          sumdata1["A2"] += this.data[key]["porpolcrenro"];
          sumdata1["A3"] += this.data[key]["mtoasegcre"];
          sumdata1["A4"] += this.data[key]["pormtoasegnro"];
          sumdata1["A5"] += this.data[key]["primacre"];
          sumdata1["A6"] += this.data[key]["porprimacrenro"];
          sumdata1["A7"] += this.data[key]["cantcotiz"];
          sumdata1["A8"] += this.data[key]["porcotnro"];
          sumdata1["A9"] += this.data[key]["mtoasegcot"];
          sumdata1["A10"] += this.data[key]["porasegcotnro"];
          sumdata1["A11"] += this.data[key]["primacot"];
          sumdata1["A12"] += this.data[key]["pormtoprimnro"];
          sumdata1["A13"] += this.data[key]["cantpolemi"];
          sumdata1["A14"] += this.data[key]["porcoteminro"];
          sumdata1["A15"] += this.data[key]["cantpolgar"];
          sumdata1["A16"] += this.data[key]["porpolgarnro"];
          sumdata1["A17"] += this.data[key]["primagar"];
          sumdata1["A18"] += this.data[key]["porprimagarnro"];

        if(this.data[key]["rutcorredor"] == undefined){
          this.data[key]["rutcorredor"] = "";
        }

        if(this.data[key]["codcorredor"] == undefined){
          this.data[key]["codcorredor"] = "";
        }

  
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["nomcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["rutcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["codcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["cantpolcre"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["porpolcre"]+ "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtoasegcre"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["pormtoaseg"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primacre"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["porprimacre"]+ "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["cantcotiz"]).format("0,0")  + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["porcot"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtoasegcot"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["pormtoasegcot"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primacot"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["pormtoprim"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["cantpolemi"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["porcotemi"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["cantpolgar"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["porpolgar"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primagar"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl289618 style='border-top:none;border-left:none;" + xl289618 + "'>" + this.data[key]["porprimagar"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
          cuerpo += "<td></td>\n";
          cuerpo += "<td></td>\n";
          cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
          //cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A1"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A1"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A2"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A3"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A4"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A5"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A6"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A7"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A8"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A9"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A10"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A11"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A12"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A13"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A14"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A15"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A16"].toFixed()+ "%" + "</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A17"]).format("0,0")+"</td>\n";
          cuerpo += "<td class=xl289618 align=right style='border-top:none;border-left:none;"+xl289618+"'>"+sumdata1["A18"].toFixed()+ "%" + "</td>\n";
       cuerpo += "</tr>\n";

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.card-header {
  background-color: #00a7d4;
  color: #fff;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}

</style>

